import { AuditOutlined } from '@ant-design/icons-vue';
import OperationLog from '@/views/audit/OperationLog.vue';

export const auditRoutes = [
    {
        path: 'operation-logs',
        component: OperationLog,
        name: 'OperationLog',
        meta: {
            title: '操作紀錄',
            icon: AuditOutlined
        }
    }
];
